/**
 * Do not edit directly
 * Generated on Thu, 29 Sep 2022 18:15:25 GMT
 */

export const componentSelectContainerBackgroundColor = "#fff";
export const componentSelectContainerBorderColorDefault = "#909196";
export const componentSelectContainerBorderColorHover = "#000";
export const componentSelectContainerBorderColorFocus = "#000";
export const componentSelectContainerBorderColorDisabled = "#babbbe";
export const componentSelectContainerBorderWidthDefault = "0.0625rem";
export const componentSelectContainerBorderWidthHover = "0.0625rem";
export const componentSelectContainerBorderWidthFocus = "0.125rem";
export const componentSelectContainerBorderWidthDisabled = "0.0625rem";
export const componentSelectContainerBorderRadius = "0.25rem";
export const componentSelectContainerSizeSmallPaddingLeft = "0.75rem";
export const componentSelectContainerSizeSmallPaddingRight = "2.25rem";
export const componentSelectContainerSizeSmallPaddingVertical = "0.5rem";
export const componentSelectContainerSizeLargePaddingLeft = "1rem";
export const componentSelectContainerSizeLargePaddingRight = "2.25rem";
export const componentSelectContainerSizeLargePaddingVertical = "1rem";
export const componentSelectContainerStateErrorBorderColorDefault = "#de1c24";
export const componentSelectContainerStateErrorBorderColorHover = "#de1c24";
export const componentSelectContainerStateErrorBorderColorFocus = "#de1c24";
export const componentSelectContainerStateErrorBorderColorDisabled = "#de1c24";
export const componentSelectContainerStateHasLeadingIconSizeSmallPaddingLeft = "2.75rem";
export const componentSelectContainerStateHasLeadingIconSizeLargePaddingLeft = "3.25rem";
export const componentSelectHelperTextAliasName = "component.form.helperText";
export const componentSelectHelperTextMarginHorizontal = "0.25rem";
export const componentSelectHelperTextMarginTop = "0.25rem";
export const componentSelectHelperTextIconAliasName = "component.form.helperTextIcon";
export const componentSelectIconIconColorDefault = "#000";
export const componentSelectIconIconColorFocus = "#000";
export const componentSelectIconIconColorHover = "#000";
export const componentSelectIconIconColorActive = "#000";
export const componentSelectIconIconColorDisabled = "#babbbe";
export const componentSelectIconIconName = "CaretDown";
export const componentSelectIconIconSize = "medium";
export const componentSelectIconSizeSmallOffsetRight = "0.75rem";
export const componentSelectIconSizeSmallOffsetTop = "0.5rem";
export const componentSelectIconSizeLargeOffsetRight = "0.75rem";
export const componentSelectIconSizeLargeOffsetTop = "1rem";
export const componentSelectLabelAliasName = "component.form.label";
export const componentSelectLabelMarginBottom = "0.25rem";
export const componentSelectLabelMarginHorizontal = "0.25rem";
export const componentSelectLeadingIconIconColor = "#74767c";
export const componentSelectLeadingIconIconSize = "medium";
export const componentSelectLeadingIconSizeSmallOffsetLeft = "0.75rem";
export const componentSelectLeadingIconSizeSmallOffsetTop = "0.5rem";
export const componentSelectLeadingIconSizeLargeOffsetLeft = "1rem";
export const componentSelectLeadingIconSizeLargeOffsetTop = "1rem";
export const componentSelectLeadingIconStateDisabledIconColor = "#babbbe";
export const componentSelectValueFontFamily = "Bogle, 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const componentSelectValueFontWeight = "400";
export const componentSelectValueSizeSmallFontSize = "0.875rem";
export const componentSelectValueSizeSmallLineHeight = "1.5rem"; // This takes into account the extra 4px missed in figma: 20px + 4px = 24px
export const componentSelectValueSizeLargeFontSize = "1rem";
export const componentSelectValueSizeLargeLineHeight = "1.5rem";
export const componentSelectValueTextColorDefault = "#2e2f32";
export const componentSelectValueTextColorHover = "#2e2f32";
export const componentSelectValueTextColorFocus = "#2e2f32";
export const componentSelectValueTextColorActive = "#2e2f32";
export const componentSelectValueTextColorDisabled = "#babbbe";